<template lang="pug">
#app(v-if='!(urlParams.token || urlParams.appid || urlParams.uid) && isShowPage' :class="{checkIsKmai}")
  Header(ref='header')
  #Login
    .first_screen
      //- 轮播图
      .banner-container
        .banner-wrapper(
          :class='{ animated: slideAnimated }',
          :style='{ transform: "translateX(" + offset + "px)" }',
          @transitionend='handleSlideEnd'
        )
          .banner(v-for='idx in "010"', :class='"b" + idx')
            img(:src='picUrl("bg" + (parseInt(idx) + 1) + ".png")')
        .banner-indicator
          div(:class='{ active: indicate % 2 === 0 }')
          div(:class='{ active: indicate % 2 === 1 }')
      //- 登录框
      Form(
        v-if='init',
        :toggleFindPwd='toggleFindPwd',
        @showRegister='openCover("register")',
        @next='next',
        ist2s=false,
        @identity="identityHandle"
        @perfectInfo='perfectInfo'
      )
    template(v-if="!checkIsKmai")
      .lazy.second_screen(name='s2')
        transition(enter-active-class='animated fadeIn')
          img(:src='picUrl("screen2.png")', v-if='imgs.s2')
      .lazy.third_screen(name='s3')
        transition(enter-active-class='animated fadeIn')
          div(v-if='imgs.s3')
            ul
              li(
                v-for='(item, index) in gallery',
                :style='{ backgroundImage: "url(https://18ks.chivoxapp.com/" + item.url + ".png)" }',
                @click='scrollPosition(index)'
              )
                div
                  span.text1 {{ item.text1 }}&nbsp;&nbsp;&nbsp;>
                  span.text2 {{ item.text2 }}
      .lazy.intro.d_scroll(v-for='index in "4567"', :name='"s" + index')
        transition(enter-active-class='animated fadeIn')
          img(:src='picUrl("screen" + index + ".png")', v-if='imgs["s" + index]')
      .lazy.eight_screen(name='s8')
        transition(enter-active-class='animated fadeIn')
          img(:src='picUrl("screen8.png")', v-if='imgs.s8')
  Footer(ref='footer')
  Sidebar
  FindPwd(
    ref='findPwd',
    :toggleFindPwd='toggleFindPwd',
    v-if='showFP',
    :identity="identity"
    @login='$store.login'
  )
  Cover(@close='closeCover', v-if='currentCoverComponent')
    register(
      v-if='currentCoverComponent === "register"',
      @disappear='closeCover',
      @perfectInfo='perfectInfo'
    )
    Activation(
      v-if='currentCoverComponent === "Activation"',
      @perfectInfo='perfectInfo',
      :numberId='numberId'
    )
    Perfect(
      v-if='currentCoverComponent === "Perfect"',
      :perfectData='perfectData',
      ref='perf'
    )
#waiting(v-else)
  img(src='/static/images/login/loading.gif')
  Form(
    v-if='init',
    @showRegister='openCover("register")',
    :toggleFindPwd='toggleFindPwd',
    @next='next',
    ist2s=false,
    @perfectInfo='perfectInfo'
  )
</template>

<script>
import { $cookie } from '@/util/Util'
import Header from './components/header'
import Footer from './components/footer'
import Sidebar from './components/Sidebar'
import Form from './components/Form'
import Cover from './components/cover'
import Activation from './components/activation'
import register from './components/register'
import Perfect from './components/perfect/app'
import { getCfg } from '@/api'

const FindPwd = () => import('./components/findPwd')

export default {
  name: 'Login',
  components: {
    Header,
    Footer,
    Sidebar,
    Form,
    FindPwd,
    Cover,
    Activation,
    register,
    Perfect,
  },
  data() {
    return {
      identity: '',
      urlParams: this.getUrlParam(),
      offset: 0,
      slideAnimated: true,
      imgs: {
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
        s7: false,
        s8: false,
      },
      gallery: [
        {
          text1: '教师的贴心助手',
          text2: '让教师轻松教学',
          url: 'screen_teacher',
        },
        {
          text1: '学生的良师益友',
          text2: '让学生更懂自己',
          url: 'screen_student',
        },
        {
          text1: '家长的放心陪读',
          text2: '让家长轻松育儿',
          url: 'screen_parent',
        },
        {
          text1: '教研的得力助手',
          text2: '让教研更懂教育',
          url: 'screen_section',
        },
      ],
      showFP: false, // 显示忘记密码对话框
      indicate: 0,
      numberId: '',
      picUrl: window.ConfigNew.logoUrl,
      init: false,
      currentCoverComponent: '',
      perfectData: {},
      isShowPage: false,
      checkIsKmai: window.ConfigNew.checkIsKmai
    }
  },
  methods: {
    identityHandle(v) {
      this.identity = v
    },
    getUrlParam() {
      let urlP = {}
      if (location.search) {
        location.search
          .substring(1)
          .split('&')
          .forEach((item) => {
            let _kv = item.split('=')
            urlP[_kv[0]] = _kv[1]
          })
      }
      return urlP
    },
    openCover(currentCoverComponent) {
      this.currentCoverComponent = currentCoverComponent
    },
    perfectInfo(perfectData) {
      this.perfectData = perfectData
      this.openCover('Perfect')
    },
    closeCover() {
      this.currentCoverComponent = ''
    },
    next(id) {
      // 1001完善个人信息
      this.numberId = id
      this.openCover('Activation')
    },
    handleSlideEnd(evt) {
      if (evt.propertyName === 'transform') {
        if (this.indicate === 2) {
          this.slideAnimated = false
          this.indicate = 0
          this.offset = 0
        }
        this.slide()
      }
    },
    slide() {
      setTimeout(() => {
        this.slideAnimated = true
        this.indicate += 1
        this.offset = 0 - document.body.clientWidth * this.indicate
      }, 2000)
    },
    scrollPosition(index) {
      let total = document.querySelectorAll('.d_scroll')[index].offsetTop
      let distance = document.documentElement.scrollTop || document.body.scrollTop
      const step = total / 50
      total > distance && smoothDown()

      function smoothDown() {
        if (distance < total) {
          distance += step
          window.scrollTo(0, distance)
          setTimeout(smoothDown, 10)
        } else {
          window.scrollTo(0, total - 90)
        }
      }
    },
    toggleFindPwd() {
      this.showFP = !this.showFP
    },
  },
  created() {
    // window.ConfigNew.resUrl + '/xxx'
    // 解密
    // $cookie.set('hasZy', data.only_zy) // 仅作业
    // $cookie.set('hasCp', data.only_cp) // 仅测评
    // $cookie.set('model', data.to_b) // 1:2B else:2C 配置
    // localStorage.setItem('cpUrl', data.cp_url)
    // localStorage.setItem('zyUrl', data.zy_url)
    // localStorage.setItem('mUrl', data.mobile_url)
    // localStorage.setItem('accUrl', data.acc_url)
    // localStorage.setItem('resUrl', data.resource_url + '/')
    let timeStamp = new Date().getTime()
    getCfg({ token: timeStamp })
      .then((data) => {
        $cookie.set('hasZy', data.only_zy) // 仅作业
        $cookie.set('hasCp', data.only_cp) // 仅测评
        $cookie.set('model', data.to_b) // 1:2B else:2C 配置
        localStorage.setItem('cpUrl', data.cpUrl)
        localStorage.setItem('zyUrl', data.zyUrl)
        localStorage.setItem('mUrl', data.mUrl)
        localStorage.setItem('accUrl', data.ywUrl)
        localStorage.setItem('resUrl', data.resource_url + '/')
        localStorage.setItem('gatewayUrl', data.gatewayUrl)
        localStorage.setItem('pcpUrl', data.pcpUrl)
        localStorage.setItem('aiUrl', data.aiUrl)

        // 判断是否要进入排队页面
        localStorage.removeItem('studentId')
        this.$queueUp().then(() => {
          this.isShowPage = true
          this.init = true
          const windowHeight = window.innerHeight
          const lazyObjs = {}
          this.$nextTick(() => {
            const lazyElms = document.getElementsByClassName('lazy')
            Array.prototype.forEach.call(lazyElms, (elm) => {
              lazyObjs[elm.attributes.name.value] = Number(
                elm.getBoundingClientRect().top
              )
            })
            window.onscroll = (evt) => {
              const height = windowHeight + window.scrollY
              for (let key in lazyObjs) {
                if (lazyObjs[key] < height - 200) {
                  this.imgs[key] = true
                  delete lazyObjs[key]
                }
              }
            }
          })
        })
      })
      .catch((res) => {
        console.info(res)
      })
    // getRegInfo().then(res => {
    //   var data = res.data
    //   localStorage.setItem('cpUrl', data.cpUrl)
    //   localStorage.setItem('zyUrl', data.zyUrl)
    //   localStorage.setItem('mUrl', data.mobileUrl)
    //   this.init = true
    // })
  },
  mounted() {
    this.slide()
  },
}
</script>

<style lang="less">
@import url('./app.less');
#waiting {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkIsKmai {
  .identityTab {
    justify-content: left !important;
    li {
      margin-right: 25px;
    }
  }
  .linkArea,
  .other_operation,
  .app.sidebarSection,
  .identityTab .parent, 
  .identityTab .headmaster,
  .loginOperation .qrCode  {
    display: none !important;
  }

} 
</style>



// WEBPACK FOOTER //
// src/components/login/App.vue